import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomizeServiceService } from 'src/app/admin/services/customize/customize-service.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-add-customer-notice-board',
    templateUrl: './add-customer-notice-board.component.html',
    styleUrls: ['./add-customer-notice-board.component.scss'],
    standalone: false
})
export class AddCustomerNoticeBoardComponent implements OnInit {

  
  constructor(
    private customizeService: CustomizeServiceService,
    private spinner: NgxSpinnerService,
    private toast: ToastrService,
    private userdata: UserdataService,
    private route: Router
  ) { }

  noticeBoardForm: any = new UntypedFormGroup({
    customization_name: new UntypedFormControl('Astrologer Notice Board', Validators.required),
    customization_type: new UntypedFormControl(8, Validators.required),
    customization_value: new UntypedFormControl('', Validators.required),
    addedBy: new UntypedFormControl(''),
    userId: new UntypedFormControl('')
  })

  ngOnInit(): void {
    this.noticeBoardForm.patchValue({userId:this.userdata.getId()})
    this.noticeBoardForm.patchValue({addedBy:this.userdata.getName()})
  }

  get f() {
    return this.noticeBoardForm.controls
  }

  addNotice(){
    this.spinner.show()
    this.customizeService.addCustomizationArray(this.noticeBoardForm.value).subscribe(
      (res:any)=>{
        this.spinner.hide()
        this.toast.success(res.message,'Success')
        this.route.navigateByUrl('/admin/push-notification/customer-notice-board')
      },err=>{
        this.spinner.hide()
        this.toast.error(err.error.message,'Error')
      }
    )
  }

}
